import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Api } from '../../lib/api';
import { useUi } from '../../store/ui';
import { GraphCanvas } from '../graph/GraphCanvas';

/** 1–3 hop neighbourhood of the open note, docked on the right. The one that gets used daily. */
export function LocalGraphPanel({ noteId }: { noteId: string | null }) {
  const [hops, setHops] = useState(1);
  const openNote = useUi((s) => s.openNote);
  const data = useQuery({ queryKey: ['graph-local', noteId, hops], queryFn: () => Api.graph.local(noteId!, hops, 200), enabled: !!noteId, staleTime: 10_000 });
  if (!noteId) return <div className="dock-empty">Open a note to see its neighbourhood.</div>;
  return (
    <div className="local-graph">
      <div className="row" style={{ padding: '2px 0 6px', gap: 6 }}>
        <span className="label">hops</span>
        {[1, 2, 3].map((h) => (
          <button key={h} className={`ghost${hops === h ? ' on' : ''}`} style={hops === h ? { color: 'var(--color-primary)', borderColor: 'var(--color-primary)' } : undefined} onClick={() => setHops(h)}>{h}</button>
        ))}
        <span className="spacer" />
        <span className="mono faint">{data.data ? `${data.data.nodes.length} · ${data.data.edges.length}` : ''}</span>
      </div>
      {data.data ? (
        <GraphCanvas data={data.data} onOpen={(id, split) => openNote(id, { split })} highlightId={noteId} height={320} />
      ) : (
        <div className="dock-empty">Loading…</div>
      )}
    </div>
  );
}
